import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FeedbackService } from '@app/core/services';
import { SavedReportFilterModel } from '../models/saved-report-fiter.model';
import { SavedReportFilterService } from '../services/saved-report-filter.service';

@Component({
	selector: 'sl-save-report-filters',
	templateUrl: './save-report-filters.component.html',
	standalone: true,
	imports: [MatDialogModule, FormsModule, ReactiveFormsModule, FormlyModule, MatButtonModule],
})
export class SaveReportFiltersComponent {
	form = new UntypedFormGroup({});

	model: SavedReportFilterModel = {
		Id: undefined,
		UserId: '',
		UserIds: [],
	};

	fields: FormlyFieldConfig[] = [
		{
			key: 'name',
			type: 'input',
			templateOptions: {
				label: 'Report Filters Name',
				required: true,
			},
		},
	];

	constructor(
		private readonly service: SavedReportFilterService,
		private readonly feedbackService: FeedbackService,
		public dialogRef: MatDialogRef<SavedReportFilterModel>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if (data) {
			this.model = { ...data };
		}
	}

	onSubmit() {
		if (this.form.valid) {
			this.model.Filters = JSON.stringify(this.model.Filters);
			this.service.createEntity(this.model).subscribe(() => {
				this.feedbackService.success('saved', 'Report Filters', { isPlural: true });
				this.dialogRef.close();
			});
		}
	}

	onCancel() {
		this.model.Name = '';
		this.dialogRef.close();
	}
}
